<template>
</template>

<script>
import { FETCH_PROFILE } from '@/store/actions.type'
import { mapGetters } from 'vuex'

export default {
  name: 'ShopifyV2IntegrationPage',
  components: {
  },
  data() {
    return {
      integrationDone: false,
      platformSlug: 'shopify-v2'
    }
  },
  props: {
    type: {
      type: String,
      default: 'ongoing'
    }
  },
  watch: {
    user: {
      handler(val) {
        if (!val || !this.$store || this.integrationDone) return
        this.integrationDone = true
        this.setShopifyIntegration()
      },
      immediate: true
    }
  },
  beforeMount() {
    this.$store.dispatch(FETCH_PROFILE)
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  methods: {
    async generateApplication() {
      const {data: response} = await this.$http.get(this.$appConfig.api.baseUrl + 'platforms')
      const platforms = response.data
      const thePlatform = platforms.find(x => x.slug === this.platformSlug)
      const application = this.getPreviousApplication(thePlatform)
      if (application) return application
      const payload = {
        name: this.user.company.name + ' ' + thePlatform.name,
        company_id: this.user.company_id,
        platform_id: thePlatform.id,
        active: true
      }
      const {data} = await this.$http.post(this.$appConfig.api.baseUrl + 'applications', payload)
      return data
    },
    getPreviousApplication(thePlatform) {
      for (const app of this.$store.getters.profile.company.applications) {
        if (!app.webhook_url) continue
        const urlObj = new URL(app.webhook_url)
        const params = new URLSearchParams(urlObj.search)
        if (app.platform && app.platform.id === thePlatform.id && params.get('userId') === String(this.user.id)) {
          return app
        }
      }
      return null
    },
    isValidCompany() {
      const isValid = this.user && this.user.company_id
      if (isValid) return true
      let obj = {
        title: 'ERROR',
        message: this.$gettextInterpolate(this.$gettext('Your user doesn\'t have a company defined which is required to be able to enjoy the benefits of the e-commerce integrations.<br><br>Please write to <a href="mailto:%{helpEmail}">%{helpEmail}</a> to get this solved.'), {helpEmail: this.helpEmail}),
        type: 'error'
      }
      this.$root.$children[0].$refs.simplert.openSimplert(obj)
      this.$router.push({ name: 'search' })
      return false
    },
    async setShopifyIntegration() {
      if (!this.isValidCompany()) return false
      const credentials = await this.generateApplication()
      const body = {
        companyId: String(this.user.company_id),
        userId: this.user.id,
        appId: credentials.id,
        appKey: credentials.key,
        shop: this.$route.query.shop,
        code: String(this.$route.query.code),
        metadata: {
          cutTimeSaturday: this.$store.getters.profile.company.cut_time_saturday || '',
          cutTimeSunday: this.$store.getters.profile.company.cut_time_sunday || '',
          cutTimeWeek: this.$store.getters.profile.company.cut_time_week || '',
          timeZone: this.$tz,
          shippingTypes: [
            {
              enabled: 1,
              title: 'Tu pedido llega ',
              description: 'Envíos rápidos con Moova',
              packagingDays: 0,
              showDeliveryDays: 1,
              amountForFreeShipping: null,
              fixedOverPrice: null,
              minPrice: null,
              maxPrice: null,
              type: 'regular'
            }
          ]
        }
      }
      const nextDayEnabledSetting = await this.$store.getters.profile.company.settings.find(x => x.name === 'next_day_shippings_enabled')
      if (nextDayEnabledSetting) {
        body.metadata.shippingTypes.push({
          enabled: 1,
          title: 'Tu pedido llega ',
          description: 'Envios rapidos con Moova',
          packagingDays: 2,
          showDeliveryDays: 1,
          amountForFreeShipping: null,
          fixedOverPrice: null,
          minPrice: null,
          maxPrice: null,
          type: 'next_day'
        })
      }
      const path = this.$appConfig.integrations.ecommerce.baseUrl + 'shopify/authenticate'
      const headers = { 'x-api-key': this.$appConfig.integrations.ecommerce.header }
      try {
        await this.$http.post(path, body, {headers})
        this.$store.dispatch(FETCH_PROFILE).then(response => {
          let payload = { profile: this.user }
          this.$store.commit('setProfile', payload)
          this.$router.push({name: 'integration-settings', params: { slug: 'shopify-v2' }})
        })
      } catch (error) {
        this.$router.push({name: 'integration-settings', params: { slug: 'shopify-v2' }})
        // return this.throwErrorIntegration(error)
      }
    }
  }
}
</script>
